import React from "react";
import TreatmentList from "../components/TreatmentList";
import { Box } from "@mui/system";
import PageHeader from "../components/PageHeader";
import { useContent } from "../app/ContentContext";

function Treatments() {
  const { treatmentsPage } = useContent();
  return (
    <Box>
      <PageHeader
        title={treatmentsPage.title}
        description={treatmentsPage.description}
      />
      <TreatmentList />
    </Box>
  );
}

export default Treatments;
